const mainStyleInner: CSSStyleDeclaration = getComputedStyle(
	document.documentElement
);

export class mainStyle {
	static getPropertyValue(key: string) {
		return mainStyleInner.getPropertyValue(key).trim();
	}
}